export default __webpack_public_path__ + "static/media/icon-droplet.d124ee0c.svg";